var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPotencia = function SvgPotencia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.78 6.22a.75.75 0 0 0-1.06 0L.4 10.983a1.494 1.494 0 0 0 0 2.032v.003l4.321 4.763A.75.75 0 0 0 6 17.249v-10.5a.75.75 0 0 0-.22-.53M12 23.282a.72.72 0 0 0 .761.717c6.273-.396 11.24-5.616 11.24-11.999S19.032.395 12.76.001a.715.715 0 0 0-.76.717V5.22a.824.824 0 0 0 .733.812 6 6 0 0 1 3.757 1.986 6.02 6.02 0 0 1 0 7.96 6 6 0 0 1-3.757 1.986.82.82 0 0 0-.734.813z"
  })));
};
export default SvgPotencia;